import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import "./Success.css";
import axios from "axios";

const Success = () => {
  const userInfo = useSelector((state) => state.amazonReducer.userInfo);
  const email = userInfo.email;
  const products = useSelector((state) => state.amazonReducer.products);

  useEffect(() => {
    const saveUser = async () => {
      try {
        // Create an array of _id values from products
        const productIds = products.map((product) => product._id);
        // console.log(productIds);

        const response = await axios.put(
          "https://snk-music-store-backend.cyclic.app/user",
          {
            email,
            productIds, // Include the array of _id values in the payload
          }
        );
        console.log(response.data);
      } catch (err) {
        console.error(err);
      }
    };

    saveUser();
  }, [email, products]);

  return (
    <div className="success-page">
      <div className="success-content">
        <h1>Thank You for Your Purchase!</h1>
        <p>Your order has been successfully processed.</p>
        <p>Thank you for choosing SNK Music Store! Enjoy your music.</p>
      </div>
    </div>
  );
};

export default Success;
